import { DistanceUnitsEnum } from '@ubnt/link-core/enums';
import { useCallback } from 'react';

import { useDispatch, useSelector } from 'app/store';
import UnitTile from 'modules/editor/components/Settings/UnitTile';
import { settingsUnitChange, settingsUnitSelector } from 'modules/settings/slice';
import { trackEvent } from 'utils/googleAnalytics';

const UnitTileContainer = () => {
  const unit = useSelector(settingsUnitSelector);

  const dispatch = useDispatch();

  const onUnitChange = useCallback(
    (newUnit: ValuesOf<typeof DistanceUnitsEnum>) => {
      dispatch(settingsUnitChange(newUnit));
      trackEvent('settingsChange', { setting: 'unit', newValue: newUnit });
    },
    [dispatch]
  );

  return <UnitTile onUnitChange={onUnitChange} unit={unit} />;
};

export default UnitTileContainer;
